import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid'
import styles from './InquiryTab.module.scss'
import ValidationMap from './ValidationMap'
import { submitInquiry } from '../../services/api'

export const InquiryTab = () => {
	const [alert, setAlert] = useState({ message: '', type: '' })

	const methods = useForm()
	const {
		register,
		handleSubmit,
		formState: { errors },
		watch,
		reset,
		setError,
		setValue,
	} = methods

	const consent = watch('consent')
	const inputContent = watch('content')
	const token = JSON.parse(localStorage.getItem('token'))
	const onValid = async (data) => {
		try {
			console.log('인자로 전달된 data:', data)
			const response = await submitInquiry(
				{
					title: data.title,
					content: data.content,
					email: data.email,
					phone: data.phone,
					consent: data.consent,
				},
				token,
			)
			setAlert({ message: '문의가 성공적으로 접수되었어요!', type: 'success' })
			reset()
			console.log('Inquiry submitted:', response)
		} catch (err) {
			setError('root.server', {
				type: 'server',
				message: '서버에 문의사항 보내기 실패',
			})
			console.error('error:', err)
		}
	}

	const onInvalid = (errors) => {
		const errorKeys = Object.keys(errors)

		// 오직 consent만 오류일 때만 알림 띄우기
		if (errorKeys.length === 1 && errorKeys[0] === 'consent') {
			setAlert({
				message: '개인정보 수집 및 이용동의를 체크해주세요',
				type: 'error',
			})
		}
	}

	useEffect(() => {
		let timer
		if (alert.message) {
			timer = setTimeout(() => {
				setAlert({ message: '', type: '' })
			}, 3000)
		}
		return () => clearTimeout(timer)
	}, [alert.message])

	return (
		<FormProvider {...methods}>
			<form className={styles.inputInfo} onSubmit={handleSubmit(onValid, onInvalid)}>
				<div className={styles.inputBlock}>
					<span className={styles.inquiryLabel}>문의 제목</span>
					<input
						{...register('title', ValidationMap.required)}
						className={`${styles.fillinput} ${errors.title ? styles.invalid : ''}`}
						maxLength={50}
						placeholder="문의 제목을 입력해주세요"
					/>
					{errors.title && (
						<span className={styles.errorMessage}>{errors.title.message}</span>
					)}
				</div>

				<div className={styles.inputBlock}>
					<div className={styles.contentHeader}>
						<span className={styles.inquiryLabel}>문의 내용</span>
						<span className={styles.lengthChecker}>
							<span className={styles.currentLength}>
								{inputContent?.length || 0}
							</span>
							<span className={styles.maxLength}>/500</span>
						</span>
					</div>
					<textarea
						{...register('content', ValidationMap.required)}
						className={`${styles.contentArea} ${errors.content ? styles.invalid : ''}`}
						maxLength={500}
						placeholder="문의 내용을 입력해주세요"
					/>
					{errors.content && (
						<span className={styles.errorMessage}>{errors.content.message}</span>
					)}
				</div>

				<div className={styles.inputBlock}>
					<span className={styles.inquiryLabel}>이메일</span>
					<input
						{...register('email', ValidationMap.email)}
						className={`${styles.fillinput} ${errors.email ? styles.invalid : ''}`}
						placeholder="답변 받을 이메일을 입력해주세요"
					/>
					{errors.email && (
						<span className={styles.errorMessage}>{errors.email.message}</span>
					)}
				</div>

				<div className={styles.inputBlock}>
					<span className={styles.inquiryLabel}>휴대폰 번호</span>
					<input
						{...register('phone', ValidationMap.phone)}
						className={`${styles.fillinput} ${errors.phone ? styles.invalid : ''}`}
						placeholder="답변 받을 휴대폰 번호를 입력해주세요"
					/>
					{errors.phone && (
						<span className={styles.errorMessage}>{errors.phone.message}</span>
					)}
				</div>

				<div className={styles.inputBlock}>
					<label htmlFor="consent" className={styles.termsLabel}>
						<input
							id="consent"
							type="checkbox"
							{...register('consent', {
								required: '개인정보 수집 및 이용동의를 체크해주세요',
							})}
							className={styles.hiddenCheckbox}
						/>
						<div className={styles.termsLabel}>
							<span className={styles.inquiryLabel} style={{ fontSize: '12px' }}>
								개인정보 수집 및 이용 동의
							</span>
						</div>
						<span className={styles.right}>
							<CheckCircleIcon
								style={{
									width: '16.25px',
									height: '16.25px',
									color: consent ? '#1B1B1B' : '#ECECEC',
								}}
							/>
						</span>
					</label>
				</div>

				<button type="submit" className={styles.submitButton}>
					문의 접수하기
				</button>

				{alert.message && (
					<div
						className={`${styles.alertMessageBox} ${alert.type === 'error' ? styles.error : styles.success}`}>
						{alert.type === 'error' ? (
							<ExclamationCircleIcon style={{ width: '18px', height: '18px' }} />
						) : (
							<CheckCircleIcon style={{ width: '16.25px', height: '16.25px' }} />
						)}
						<p>{alert.message}</p>
					</div>
				)}

				<div className={styles.subTextLabel}>
					<div className={styles.subText}>
						기업 제휴 및 스폰서십 문의는 이메일 또는 카카오톡 채널로 연락 주시면 상세히
						안내해 드립니다.
					</div>
					<div className={styles.divider} />
					<div className={styles.subText}>
						이메일 : master@spoeum.com <br />
						카카오톡 : spoeum |{' '}
						<a
							className={styles.kakaotalkLink}
							href="http://pf.kakao.com/_vAAxiK/chat"
							target="_blank"
							rel="noopener noreferrer">
							카카오톡 링크
						</a>
					</div>
				</div>
			</form>
		</FormProvider>
	)
}
